import { Component,ViewEncapsulation, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { GeneralService } from '../../../../services/general/general.service';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
import moment from 'moment';
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { ReplaySubject } from 'rxjs';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['../../../../../shared-styles/settings.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  encapsulation: ViewEncapsulation.None
})
export class IndexComponent implements OnInit, OnDestroy {
  public isMobile: any;
  public headerHeight = 0;
  public form: FormGroup;
  public loading = false;
  public sending = false;
  public languages = new Array();
  public countries = new Array();
  public cities = new Array();
  public countryFilteredOptions: any;
  public languageLevels = new Array();
  public levels = new Array();
  public subscriptions = new Array();
  public genders = ['man', 'woman'];
  //Student Want to Study
  public typeLessons: FormControl = new FormControl('languages');
  public allLessons: any = {};
  public lessons: any = [];
  public lessonFilterCtrl: FormControl = new FormControl();
  public filteredLessons: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public payments: any;

  constructor(
    public general: GeneralService,
    private formBuilder: FormBuilder,
    private dialog: MatDialog
  ) {
    this.isMobile = this.general.isMobile();

    this.form = this.formBuilder.group(
      {
        name: ['', [Validators.required]],
        surname: ['', [Validators.required]],
        email: [{ value: null, disabled: true }, [Validators.required]],
        birthday: ['', [Validators.required]],
        phone: ['', [Validators.required, Validators.pattern('[- +()0-9]+')]],
        gender: ['', [Validators.required]],
        country: ['', [Validators.required]],
        custom_city_name: ['', [Validators.required]],
        languages: this.formBuilder.array([]),
        profile_photo_path: [''],
        photo_base64: [''],
        goal_joining: ['', [Validators.required]],
        educational_level: ['', [Validators.required]],
        dedication_time: ['', [Validators.required]],
        other_goal_joining: ['', []],
        student_lesson_id: ['', [Validators.required]],
      },
      {
        validators: [this.checkImage(), this.validateCountryAndCity()],
      }
    );
  }

  async ngOnInit() {
    try {
      document.addEventListener('set-lang', this);
      window.dispatchEvent(new CustomEvent('calendar-hide-label'));
      window.dispatchEvent(new CustomEvent('hide-side-nav'));
      this.intializeSubscriptions();
      await this.loadData();
      this.filteredLessons.next(this.lessons.slice());
    } catch (error: any) {
      await this.general.showDanger(error.message);
    }
  }

  async loadData() {
    try {
      this.general.setLoading(true);
      this.languagesFormArray.clear();
      // this.loading = true;
      const requests = [
        this.general.httpGet('study-lessons'),
        this.general.httpGet('countries'),
        this.general.httpGet('lessons-levels'),
        this.general.httpGet('student-profile-about-data'),
        this.general.httpGet('student-payments-info'),

      ];
      const response: any = await this.general.forkJoin(requests);
      this.languages = response[0].data.filter(
        (subject: any) => subject.type === 'language'
      );
      
      // Recogida de pagos
      this.payments = response[4].message;
      console.log("Pagos", this.payments);
      
      this.allLessons = response[0].data;
      this.lessons = this.languages;

      this.countries = response[1].data;
      this.levels = response[2].data;
      this.languageLevels = response[2].data.filter(
        (subject: any) => subject.type === 'language'
      );

      let country = this.countries.find(
        (country: any) => country.id === response[3].data.country.id
      );
      if (country) {
        const countryCities = await this.general.httpGet('cities', {
          country_id: country.id,
        });
        this.cities = countryCities.data;
      }

      const currentLesson = this.allLessons.find((lesson: any) => {
        return lesson.id === response[3].data.lesson_id;
      });

      if (currentLesson) {
        this.typeLessons.patchValue(`${currentLesson.type}s`);
      }

      // Patch form
      this.form.patchValue({
        profile_photo_path: response[3].data.profile_photo_path,
        name: response[3].data.name,
        surname: response[3].data.surname,
        email: response[3].data.email,
        birthday: response[3].data.birthday,
        phone: response[3].data.phone,
        gender: response[3].data.gender,
        country,
        custom_city_name: response[3].data.city.name,
        goal_joining: response[3].data.goal_joining,
        educational_level: response[3].data.educational_level,
        dedication_time: response[3].data.dedication_time,
        other_goal_joining: response[3].data.other_goal_joining,
        student_lesson_id: currentLesson ? currentLesson : '',
      });
      const currentLanguages = JSON.parse(response[3].data.languages_ids);
      const currentLevels = JSON.parse(response[3].data.languages_levels_ids);

      if (currentLanguages && currentLanguages.length) {
        currentLanguages.forEach((langId: any, index: any) => {
          this.languagesFormArray.push(
            this.formBuilder.group({
              language_id: [langId, [Validators.required]],
              level_id: [currentLevels[index], [Validators.required]],
            })
          );
        });
      } else {
        this.languagesFormArray.push(
          this.formBuilder.group({
            language_id: ['', [Validators.required]],
            level_id: ['', [Validators.required]],
          })
        );
      }
    } catch (error: any) {
      await this.general.showDanger(error.message);
    } finally {
      this.general.setLoading(false);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });
    document.removeEventListener('set-lang', this);
  }

  // Handle event Listener
  async handleEvent(event: any) {
    switch (event.type) {
      case 'set-lang':
        await this.loadData();
        break;
    }
  }

  /**
   * =================== Functions ===================
   */

  async sureDelAccount() {

    const removeDialogRef = await this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Desactivar y eliminar cuenta. Si solicitas eliminar tu cuenta perderás todas las horas que tengas compradas.',
      },
      autoFocus: false,
    });

    const subscribed = await removeDialogRef.afterClosed().subscribe((response) => {
      subscribed.unsubscribe();

      if (!response) {
        return;
      }else{
       
        console.log("Llamada a desactivar alumno");
        this.delAccount();
      }
      
    });

  }

  async delAccount(){
    try {
      const requests = [this.general.httpGet('delete-me')];
      const response: any = await this.general.forkJoin(requests);
      console.log(response);
      if (response.success==true) {
        // borramos local storage y redirigimos al login
         localStorage.clear();
         await this.general.navigate('/auth/login');
       } else {
         await this.general.showDanger(response.message);
       }
        
      
    } catch (err) {
        console.log(err);
        
    }
  }


  intializeSubscriptions() {
    this.subscriptions = [
      this.general.loading$.subscribe((res) => (this.loading = res)),
      this.form.controls.country.valueChanges.subscribe(async (data) => {
        try {
          if (
            !this.loading &&
            typeof data === 'object' &&
            !Array.isArray(data) &&
            data !== null
          ) {
            const response = await this.general.httpGet('cities', {
              country_id: data.id,
            });
            this.cities = response.data;
          }
        } catch (error) {
          console.log(error);
        }
      }),
      this.lessonFilterCtrl.valueChanges.pipe().subscribe(() => {
        this.filterLesson();
      }),
      this.typeLessons.valueChanges.subscribe((val) => {
        this.lessons = this.allLessons.filter(
          (lesson: any) => lesson.type == val.slice(0, -1)
        );
        this.filteredLessons.next(this.lessons.slice());
        this.form.patchValue({
          student_lesson_id: this.lessons[0],
        });
      }),
    ];
  }

  async sendform() {
    try {
      console.log(this.form.value);
      this.sending = true;
      const formData: any = new FormData();
      formData.append('name', this.form.value.name);
      formData.append('surname', this.form.value.surname);
      formData.append('country_id', this.form.value.country.id);
      formData.append('custom_city_name', this.form.value.custom_city_name);

      formData.append('phone', this.form.value.phone);
      formData.append('gender', this.form.value.gender);
      formData.append(
        'birthday',
        moment(this.form.value.birthday).format('YYYY-MM-DD')
      );
      formData.append('languages', JSON.stringify(this.form.value.languages));
      if (this.form.value.photo_base64) {
        formData.append('profile_photo_path', this.form.value.photo_base64);
      }
      formData.append('goal_joining', this.form.value.goal_joining);
      if (this.form.value.other_goal_joining) {
        formData.append(
          'other_goal_joining',
          this.form.value.other_goal_joining
        );
      }
      formData.append('educational_level', this.form.value.educational_level);
      formData.append('dedication_time', this.form.value.dedication_time);

      formData.append('lesson_id', this.form.value.student_lesson_id.id);

      const response = await this.general.httpPost(
        'upd-student-profile-about-data',
        formData
      );
      await this.general.showSuccess('data-saved-successfully');
    } catch (error) {
      await this.general.showErrorForm(error);
      console.log(error);
    } finally {
      this.sending = false;
    }
  }

  filterLesson() {
    if (!this.lessons) {
      return;
    }
    // get the search keyword
    let search = this.lessonFilterCtrl.value;
    if (!search) {
      this.filteredLessons.next(this.lessons.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredLessons.next(
      this.lessons.filter(
        (lesson: any) =>
          lesson.name
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .indexOf(search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')) >
          -1
      )
    );
  }

  /**
   * =================== Validations Form ===================
   */
  validateCountryAndCity() {
    return (formGroup: FormGroup) => {
      let res = null;

      // return if another validator has already found an error on the matchingControl
      if (formGroup.errors && !formGroup.errors.badOrder) {
        return;
      }

      const countryControl = formGroup.controls['country'];
      const cityControl = formGroup.controls['custom_city_name'];

      if (typeof countryControl.value !== 'object') {
        countryControl.setErrors({ notObject: true });
      }

      if (!cityControl.value) {
        cityControl.setErrors({ notObject: true });
      }
    };
  }

  checkImage() {
    return (formGroup: FormGroup) => {
      if (formGroup.errors && !formGroup.errors.badOrder) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // Is not necessary
      return;
      const baseControl = formGroup.controls['photo_base64'];
      const pathControl = formGroup.controls['profile_photo_path'];

      if (!pathControl.value && !baseControl.value) {
        baseControl.setErrors({ noPhoto: true });
      }
    };
  }

  get invalidLessonToStudy() {
    return (
      this.form.get('student_lesson_id')?.invalid &&
      this.form.get('student_lesson_id')?.touched
    );
  }

  get birthdayNoValido() {
    return (
      this.form.get('birthday')?.invalid && this.form.get('birthday')?.touched
    );
  }
  get dniNoValido() {
    return this.form.get('dni')?.invalid && this.form.get('dni')?.touched;
  }
  get phoneNoValido() {
    return this.form.get('phone')?.invalid && this.form.get('phone')?.touched;
  }
  get genderNoValido() {
    return this.form.get('gender')?.invalid && this.form.get('gender')?.touched;
  }

  get validateform() {
    return this.form.valid;
  }

  get invalidDedicationTime() {
    return (
      this.form.get('dedication_time')?.invalid &&
      this.form.get('dedication_time')?.touched
    );
  }
  get invalidEducationalLevel() {
    return (
      this.form.get('educational_level')?.invalid &&
      this.form.get('educational_level')?.touched
    );
  }
  get invalidGoalJoining() {
    return (
      this.form.get('goal_joining')?.invalid &&
      this.form.get('goal_joining')?.touched
    );
  }
  get invalidOtherGoalJoining() {
    return (
      this.form.get('other_goal_joining')?.invalid &&
      this.form.get('other_goal_joining')?.touched
    );
  }

  get invalidCustomCityName() {
    return (
      this.form.get('custom_city_name')?.invalid &&
      this.form.get('custom_city_name')?.touched
    );
  }

  onSelectFile(event: any, atr: any) {
    if (event.files.item(0)) {
      const body: any = {};
      body[atr] = event.files.item(0);
      this.form.patchValue(body);

      setTimeout(() => {
        const $source: any = document.getElementById('photo');
        $source.setAttribute('src', URL.createObjectURL(this.form.value[atr]));
      }, 200);
    }
  }

  /**
   * =================== Languages Form 2 ===================
   */
  get languagesFormArray(): any {
    return this.form.get('languages') as FormArray;
  }

  addLanguage(): void {
    this.languagesFormArray.push(
      this.formBuilder.group({
        language_id: ['', [Validators.required]],
        level_id: ['', [Validators.required]],
      })
    );
  }

  removeLanguage(index: any): void {
    this.languagesFormArray.removeAt(index);
  }
}
